import React, { useState } from "react";
import { Link } from "react-router-dom";

import Container from "./Container";
import Button from "./Button";

const CookiesBanner = () => {
  const [accepted, setAccepted] = useState(false);

  function handleClick() {
    localStorage.setItem("cookiesAccepted", true);
    setAccepted(true);
  }

  if (accepted || localStorage.cookiesAccepted) {
    return null;
  }

  return (
    <div className="banner">
      <Container>
        <div className="flex align-center space-between">
          <div className="banner__content mr-30">
            <div>
              We use cookies to improve your experience on our site. To find out
              more, read our <Link to="/privacy-policy">privacy policy</Link>,{" "}
              <Link to="terms-of-use">terms of service</Link> and{" "}
              <Link to="/end-user-agreement">end user agreement</Link>.
            </div>
          </div>
          <Button onClick={handleClick}>I Agree</Button>
        </div>
      </Container>
    </div>
  );
};

export default CookiesBanner;
